// extracted by extract-css-chunks-webpack-plugin
module.exports = {"closeButton":"app-components-modal-location-location--closeButton"};